/**
 * RelivConferenceService
 * @constructor
 */
var RelivConferenceService = function (rcmApiLibService, rcmLoading, rcmApiLibMessageService, translateFilter) {
    /**
     * self
     */
    var self = this;

    var apiUrl = {
        conference: '/api/conference/{conferenceId}',
        conferences: '/api/conference',
        conferenceAccess: '/api/conference-access',
    };

    var onApiSuccess = function (response) {

    };

    var onApiError = function (response) {

    };
    /**
     * ticketOptions
     * @type {{translationLangCode: *[], hearingImpaired: *[], signLanguage: *[]}}
     */
    self.ticketOptions = {
        'translationLangCode': [
            {
                'key': 'eng',
                'value': translateFilter('None'),
            },
            {
                'key': 'spa',
                'value': translateFilter('Spanish'),
            },
        ],
        'hearingImpaired': [
            {
                'key': 1,
                'value': translateFilter('Yes'),
            },
            {
                'key': 0,
                'value': translateFilter('No'),
            },
        ],
        'signLanguage': [
            {
                'key': 1,
                'value': translateFilter('Yes'),
            },
            {
                'key': 0,
                'value': translateFilter('No'),
            },
        ],
    };

    /**
     *
     * @param response
     * @returns {boolean}
     */
    self.validateConferenceData = function (response) {

        if (response.data.length < 1) {
            response.messages.push(
                {
                    code: 'noConferences',
                    primary: true,
                    source: 'conferenceTicketsSelector',
                    type: 'conferenceValidator',
                    value: 'No active conferences found.',
                }
            );
            return false;
        }

        return true;
    };

    /**
     * @returns {*}
     */
    self.getConferenceAccess = function () {
        return rcmApiLibService.get(
            {
                url: apiUrl.conferenceAccess,
                loading: function (loading) {
                    var loadingInt = Number(!loading);
                    rcmLoading.setLoading(
                        'relivConferenceService.conferenceAccess.loading',
                        loadingInt
                    );
                },
                success: function (response) {
                    onApiSuccess(response);
                },
                error: function (response) {
                    onApiError(response);
                },
            }
        );
    };

    /**
     * getConference
     * @param conferenceId
     * @param onSuccess
     * @param onError
     * @returns {Promise}
     */
    self.getConference = function (conferenceId, onSuccess, onError) {
        return rcmApiLibService.get(
            {
                url: apiUrl.conference,
                urlParams: {
                    conferenceId: conferenceId,
                },
                loading: function (loading) {
                    var loadingInt = Number(!loading);
                    rcmLoading.setLoading(
                        'relivConferenceService.getConference.loading',
                        loadingInt
                    );
                },
                success: function (response) {

                    if (!self.validateConferenceData(response)) {
                        onApiError(response);
                        onError(response);
                        return;
                    }
                    onApiSuccess(response);
                    onSuccess(response);

                },
                error: function (response) {
                    onApiError(response);
                    onError(response);
                },
            }
        );
    };

    /**
     * getAllConferences
     * @param onSuccess
     * @param onError
     * @returns {Promise}
     */
    self.getAllConferences = function (onSuccess, onError) {
        return rcmApiLibService.get(
            {
                url: apiUrl.conferences,
                params: {all: 1},
                loading: function (loading) {
                    var loadingInt = Number(!loading);
                    rcmLoading.setLoading(
                        'relivConferenceService.getConference.loading',
                        loadingInt
                    );
                },
                success: function (response) {
                    onApiSuccess(response);
                    onSuccess(response);

                },
                error: function (response) {
                    onApiError(response);
                    onError(response);
                },
            }
        );
    };

    /**
     * getConferences (active only)
     * @param onSuccess
     * @param onError
     * @returns {Promise}
     */
    self.getConferences = function (onSuccess, onError) {
        return rcmApiLibService.get(
            {
                url: apiUrl.conferences,
                loading: function (loading) {
                    var loadingInt = Number(!loading);
                    rcmLoading.setLoading(
                        'relivConferenceService.getConference.loading',
                        loadingInt
                    );
                },
                success: function (response) {
                    onApiSuccess(response);
                    onSuccess(response);

                },
                error: function (response) {
                    onApiError(response);
                    onError(response);
                },
            }
        );
    };

    /**
     *
     * @param conferences
     * @param conferencesIndex
     * @returns {*}
     */
    self.indexConferences = function (conferences, conferencesIndex) {
        if ((typeof conferencesIndex !== 'object') || (conferencesIndex === null)) {
            conferencesIndex = {};
        }

        for (var i = 0; i < conferences.length; i++) {
            conferencesIndex[conferences[i].id] = angular.copy(conferences[i]);
            conferencesIndex[conferences[i].id].skuIndex = {};
            conferencesIndex[conferences[i].id].skuIndex = self.indexSkus(
                conferences[i],
                conferencesIndex[conferences[i].id].skuIndex
            );
        }

        return conferencesIndex;
    };

    /**
     *
     * @param conference
     * @param conferenceSkuIndex
     * @returns {*}
     */
    self.indexSkus = function (conference, conferenceSkuIndex) {

        if ((typeof conferenceSkuIndex !== 'object') || (conferenceSkuIndex === null)) {
            conferenceSkuIndex = {};
        }

        conferenceSkuIndex = self.indexSkusByType('skus', conference, conferenceSkuIndex);
        conferenceSkuIndex = self.indexSkusByType('availableSkus', conference, conferenceSkuIndex);

        return conferenceSkuIndex;
    };

    /**
     *
     * @param conference
     * @param tickets
     * @param skuIndex
     * @returns {*}
     */
    self.indexAvailableSkusForExistingTickets = function (conference, tickets, skuIndex) {
        if ((typeof skuIndex !== 'object') || (skuIndex === null)) {
            skuIndex = {};
        }
        skuIndex = self.indexSkus(conference, skuIndex);

        for (var i = 0; i < tickets.length; i++) {

            skuIndex[tickets[i].productId].availableSkus = self.buildAvailableSkusIndexWithMissingSkuNumber(
                tickets[i].skuNumber,
                skuIndex[tickets[i].productId]
            );

            self.indexAvailableSkusForExistingFeatures(
                tickets[i].featureData,
                skuIndex
            );
        }

        return skuIndex;
    };

    /**
     *
     * @param skuIndex
     * @param featureData
     */
    self.indexAvailableSkusForExistingFeatures = function (featureData, skuIndex) {
        if ((typeof skuIndex !== 'object') || (skuIndex === null)) {
            skuIndex = {};
        }

        for (var i in featureData) {

            skuIndex[featureData[i].productId].availableSkus = self.buildAvailableSkusIndexWithMissingSkuNumber(
                featureData[i].skuNumber,
                skuIndex[featureData[i].productId]
            );
        }

        return skuIndex;
    };

    /**
     * If a skuNumber became unavailable, we need to add it back to the UI to show the selection
     * We also mark it as invalid
     * @param skuNumber
     * @param skuIndexProduct AKA skuIndex[ticket.productId]
     */
    self.buildAvailableSkusIndexWithMissingSkuNumber = function (skuNumber, skuIndexProduct) {

        if (!skuIndexProduct) {
            // nothing available
            return {};
        }

        var allSkusIndex = skuIndexProduct.skus;

        if (!allSkusIndex) {
            // nothing available
            return {};
        }

        var tempAvailableSkusIndex = skuIndexProduct.availableSkus;

        if (!tempAvailableSkusIndex) {
            tempAvailableSkusIndex = {};
        }

        var availableSkusIndex = angular.copy(tempAvailableSkusIndex, {});

        return self.getAvailableSkusIndexWithMissingSkuNumber(skuNumber, availableSkusIndex, allSkusIndex);
    };

    /**
     *
     * @param skuNumber
     * @param availableSkusIndex
     * @param allSkusIndex
     * @returns {*}
     */
    self.getAvailableSkusIndexWithMissingSkuNumber = function (skuNumber, availableSkusIndex, allSkusIndex) {

        if (!skuNumber) {
            return availableSkusIndex;
        }

        if (availableSkusIndex[skuNumber]) {
            return availableSkusIndex;
        }

        if (!allSkusIndex[skuNumber]) {
            return availableSkusIndex;
        }

        availableSkusIndex[skuNumber] = allSkusIndex[skuNumber];
        availableSkusIndex[skuNumber].invalid = true;

        return availableSkusIndex;
    };

    /**
     *
     * @param type
     * @param conference
     * @param conferenceSkuIndex
     * @returns {*}
     */
    self.indexSkusByType = function (type, conference, conferenceSkuIndex) {
        if ((typeof conferenceSkuIndex !== 'object') || (conferenceSkuIndex === null)) {
            conferenceSkuIndex = {};
        }

        conferenceSkuIndex = self.indexSkusForProduct(
            type,
            conference.ticketProduct,
            conferenceSkuIndex
        );

        for (var ii = 0; ii < conference.featureProducts.length; ii++) {
            conferenceSkuIndex = self.indexSkusForProduct(
                type,
                conference.featureProducts[ii],
                conferenceSkuIndex
            );
        }

        return conferenceSkuIndex;
    };

    /**
     *
     * @param type
     * @param product
     * @param conferenceSkuIndex
     * @returns {{}|*}
     */
    self.indexSkusForProduct = function (type, product, conferenceSkuIndex) {
        if ((typeof conferenceSkuIndex !== 'object') || (conferenceSkuIndex === null)) {
            conferenceSkuIndex = {};
        }

        for (var i = 0; i < product[type].length; i++) {
            conferenceSkuIndex = self.indexSku(
                type,
                product.productId,
                product[type][i],
                conferenceSkuIndex
            );
        }

        return conferenceSkuIndex;
    };

    /**
     * For a single conference
     * @param type
     * @param productId
     * @param {*} sku
     * @param conferenceSkuIndex
     * @returns {{}|*}
     */
    self.indexSku = function (type, productId, sku, conferenceSkuIndex) {

        if (!conferenceSkuIndex) {
            conferenceSkuIndex = {};
        }

        if (!conferenceSkuIndex[productId]) {
            conferenceSkuIndex[productId] = {};
        }

        if (!conferenceSkuIndex[productId][type]) {
            conferenceSkuIndex[productId][type] = {};
        }

        conferenceSkuIndex[productId][type] = self.getSkuNumberIndex(sku, conferenceSkuIndex[productId][type]);

        return conferenceSkuIndex;
    };

    /**
     *
     * @param skus
     * @param skuNumberIndex
     * @returns {*}
     */
    self.getSkuNumbersIndex = function (skus, skuNumberIndex) {
        if ((typeof skuNumberIndex !== 'object') || (skuNumberIndex === null)) {
            skuNumberIndex = {};
        }

        for (var i = 0; i < skus.length; i++) {
            skuNumberIndex = self.getSkuNumberIndex(skus[i], skuNumberIndex);
        }

        return skuNumberIndex;
    };

    /**
     *
     * @param sku
     * @param skuNumberIndex
     * @returns {*}
     */
    self.getSkuNumberIndex = function (sku, skuNumberIndex) {
        if ((typeof skuNumberIndex !== 'object') || (skuNumberIndex === null)) {
            skuNumberIndex = {};
        }

        skuNumberIndex[sku.number] = sku;

        return skuNumberIndex;
    };
};

/**
 * relivConference.relivConferenceService
 */
angular.module('relivConference').service(
    'relivConferenceService',
    [
        'rcmApiLibService',
        'rcmLoading',
        'rcmApiLibMessageService',
        'translateFilter',
        function (
            rcmApiLibService,
            rcmLoading,
            rcmApiLibMessageService,
            translateFilter
        ) {
            return new RelivConferenceService(
                rcmApiLibService,
                rcmLoading,
                rcmApiLibMessageService,
                translateFilter
            );
        },
    ]
);
